<form [formGroup]="formParams" *ngIf="formParams">
	<div class="zk-w-full zk-mb-2" *ngIf="checkProfessionalPersonBlockedEditPaymentaccount()">
		<app-alert-info-status-block-edit-bank-data
			[text]="buildAlertTextToWhenBlockEditPaymentAccount()"></app-alert-info-status-block-edit-bank-data>
	</div>
	<div id="payment-content" class="
			zk-flex zk-w-full zk-flex-col
			xl:zk-grid
			zk-grid-cols-2 zk-gap-x-8 zk-gap-y-4
		">
		<div>
			<div class="zk-w-full zk-flex zk-flex-wrap zk-gap-4 zk-gap-x-0">
				<div class="zk-w-full" [class.zk-mb-2]="!isFieldInvalid('bankName')"
					[class.disabled-field]="checkAllowUpdatePaymentMethod()">
					<auto-complete [allowChangeBank]="checkAllowUpdatePaymentMethod()"
						[bankSelected]="formParams.get('bankFullName').value" [inputStatus]="
							isFieldInvalid('ispb') || isFieldInvalid('bankFullName')
								? 'error'
								: 'default'
						" (selectedBank)="onSelectBank($event)"></auto-complete>
					<span class="
							zk-block
							zk-w-full
							zk-text-left
							zk-text-xs
							zk-pt-3
							zk-px-4
							zk-text-error
						" *ngIf="isFieldInvalid('bankName')">
						{{
						'MY_ACCOUNT.FINANCIAL.BANK_DATA.FIELD_ERROR.BANK_NAME' | translate
						}}
					</span>
				</div>
				<div class="zk-w-full">
					<zk-input class="sm:zk-mt-1" [zkStatus]="isFieldInvalid('agency') ? 'error' : 'default'">
						<input [disabled]="checkAllowUpdatePaymentMethod()" id="bank-data-agency" zkInputRef [mask]="'0000'"
							formControlName="agency" class="md:zk-pr-0" [class.disabled-field]="checkAllowUpdatePaymentMethod()"
							placeholder="{{
								'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.AGENCY' | translate
							}}" />
						<span zkInputLabel>{{
							'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.AGENCY' | translate
							}}</span>
						<span zkInputMessage>
							<ng-container *ngIf="!isFieldInvalid('agency')">
								{{
								'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.AGENCY_DESCRIPTION'
								| translate
								}}
							</ng-container>
							<ng-container *ngIf="isFieldInvalid('agency')">
								{{
								'MY_ACCOUNT.FINANCIAL.BANK_DATA.FIELD_ERROR.AGENCY'
								| translate
								}}
							</ng-container>
						</span>
					</zk-input>
				</div>

				<div class="zk-w-8/12">
					<zk-input class="sm:zk-mt-1" [zkStatus]="isFieldInvalid('account') ? 'error' : 'default'">
						<input id="bank-data-account" zkInputRef formControlName="account" [mask]="'00000000000000000000'"
							[validation]="false" [disabled]="checkAllowUpdatePaymentMethod()"
							[class.disabled-field]="checkAllowUpdatePaymentMethod()" class="md:zk-pr-0" placeholder="{{
								'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.ACCOUNT' | translate
							}}" />
						<span zkInputLabel>{{
							'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.ACCOUNT' | translate
							}}</span>
						<span zkInputMessage>
							<ng-container *ngIf="isFieldInvalid('account')">
								<ng-container *ngIf="!formParams.get('account').value">
									{{
									'MY_ACCOUNT.FINANCIAL.BANK_DATA.FIELD_ERROR.ACCOUNT'
									| translate
									}}
								</ng-container>
								<ng-container *ngIf="formParams.get('account').value">
									{{
									'MY_ACCOUNT.FINANCIAL.BANK_DATA.FIELD_ERROR.ACCOUNT_INVALID'
									| translate
									}}
								</ng-container>
							</ng-container>
						</span>
					</zk-input>
				</div>

				<div class="zk-w-4/12 zk-pl-4">
					<zk-input class="sm:zk-mt-1" [zkStatus]="isFieldInvalid('accountDigit') ? 'error' : 'default'">
						<input id="bank-data-account-digit" zkInputRef [mask]="'AA'" [validation]="false"
							[disabled]="checkAllowUpdatePaymentMethod()" [class.disabled-field]="checkAllowUpdatePaymentMethod()"
							formControlName="accountDigit" class="md:zk-pr-0" placeholder="{{
								'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.ACCOUNT_DIGIT' | translate
							}}" />
						<span zkInputLabel>{{
							'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.ACCOUNT_DIGIT' | translate
							}}</span>
						<span zkInputMessage>
							{{
							'MY_ACCOUNT.FINANCIAL.BANK_DATA.FORM.ACCOUNT_DIGIT_DESCRIPTION'
							| translate
							}}
						</span>
					</zk-input>
				</div>
			</div>
		</div>

		<div class="zk-w-full">
			<div class="pix-card zk-p-4 zk-rounded-md zk-mb-4 lg:zk-mb-0"
				[class.disabled-field]="checkAllowUpdatePaymentMethod()">
				<div>
					<div class="text-color-dark-neutral-1 zk-font-thick zk-mb-2">
						{{ 'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.TITLE' | translate }}
					</div>
					<div class="zk-text-xs pix-text-description">
						{{ 'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.DESCRIPTION' | translate }}
					</div>
				</div>

				<div class="dropdown zk-mb-6 zk-mt-7" [class.disabled-field]="checkAllowUpdatePaymentMethod()">
					<zk-dropdown id="bank-data-pix-type" #dropdownComponent [label]="
							'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.SELECT_LABEL' | translate
						" [placeholder]="
							'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.SELECT_PLACEHOLDER'
								| translate
						" [disabled]="formParams.get('pixType')?.disabled" formControlName="pixType" [options]="keyOptions"
						[zkStatus]="isFieldInvalid('pixType') ? 'error' : 'default'">
					</zk-dropdown>

					<div class="zk-mt-7" [class.zk-hidden]="
							!formParams?.get('pixType')?.value ||
							formParams.get('pixType')?.disabled
						">
						<zk-input-phone id="bank-data-pix-key-phone" *ngIf="formParams.get('pixType').value === 'phone'"
							formControlName="pixKey" [disabled]="checkAllowUpdatePaymentMethod()"
							[label]="'MY_ACCOUNT.PERSONAL.MOBILEPHONE' | translate"
							[class.has-value]="formParams.get('pixKey')?.value"
							[status]="isFieldInvalid('pixKey') ? 'error' : 'default'" [message]="
								isFieldInvalid('pixKey') ? (getPixKeyError() | translate) : ''
							"></zk-input-phone>

						<zk-input *ngIf="formParams.get('pixType').value != 'phone'" class="sm:zk-mt-1"
							[zkStatus]="isFieldInvalid('pixKey') ? 'error' : 'default'">
							<input id="bank-data-pix-key" zkInputRef [disabled]="checkAllowUpdatePaymentMethod()"
								[class.disabled-field]="checkAllowUpdatePaymentMethod()" [dropSpecialCharacters]="false"
								formControlName="pixKey" [mask]="getPixMask()" class="md:zk-pr-0" placeholder="{{
									'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.KEY' | translate
								}}" />
							<span zkInputLabel>{{
								'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.KEY' | translate
								}}</span>
							<span zkInputMessage>
								<ng-container *ngIf="isFieldInvalid('pixKey')">
									{{ getPixKeyError() | translate }}
								</ng-container>
							</span>
						</zk-input>
					</div>
				</div>

				<div class="zk-w-full zk-flex" [class.disabled-field]="checkAllowUpdatePaymentMethod()">
					<input [disabled]="checkAllowUpdatePaymentMethod()" type="checkbox" class="zk-w-5 zk-h-5"
						formControlName="dontAcceptPix" />
					<div class="text-color-2 zk-mt-1 zk-ml-5">
						{{ 'MY_ACCOUNT.FINANCIAL.BANK_DATA.PIX.WITHOUT_PIX' | translate }}
					</div>
				</div>
			</div>
		</div>
	</div>
</form>
